<template>
  <div v-if="address !== null && $store.state.address.google">
    <!-- Select from existing adddress -->
    <template v-if="mode === 'select' && !replaceable">
      <div :class="groupClass">
        <label :class="lableClass" :for="name">
          <slot>{{ title }}</slot>
        </label>

        <div :class="fieldClass">
          <!--Special Part Starts-->
          <select
            :id="`${name}-select`"
            :key="name"
            :class="{ 'is-invalid': form && form.errors.has(errorId) }"
            :disabled="!initalised"
            :name="name"
            class="form-control custom-select"
            @change="selected($event.target.value)"
          >
            <option
              v-for="loopAddress in addresses"
              :key="loopAddress.id"
              :selected="loopAddress.id === address.id || loopAddress.id === selectedAddressId"
              :value="loopAddress.id"
            >
              {{ loopAddress.formatted }}
            </option>
            <option v-if="!replaceable" value="">>>> Create a new address</option>
          </select>
          <!--Special Part Ends-->

          <div
            v-if="form && form.errors.has(errorId)"
            class="invalid-feedback"
            v-text="form.errors.get(errorId)"
          ></div>
          <slot name="note"></slot>
        </div>

        <div :class="extraSlotClass">
          <slot name="extra">
            <button
              v-if="showResetToNewButton"
              class="btn btn-danger"
              type="button"
              @click.prevent="resetToNewAddress()"
            >
              <font-awesome-icon :icon="['fal', 'times']" />
            </button>
          </slot>
        </div>
      </div>
    </template>

    <!-- New Address via Google Places Autocomplete -->
    <template v-else>
      <form-google-address
        ref="googleAddress"
        :bottom-margin="bottomMargin"
        :error-name="errorName"
        :labelless="labelless"
        :name="name"
        :single-row="singleRow"
        :value="address.formatted"
        @error="handleError"
        @input="googleAddressUpdated"
      >
        <template #extra>
          <button
            :class="$lodash.has($slots, 'extra') ? 'mr-2' : ''"
            class="btn btn-primary form-action-button"
            type="button"
            @click.prevent="expand"
          >
            <font-awesome-icon v-if="expanded" :icon="['fal', 'layer-minus']" />
            <font-awesome-icon v-else :icon="['fal', 'layer-plus']" />
          </button>
          <slot name="extra"></slot>
        </template>
      </form-google-address>

      <div v-show="expanded">
        <form-text v-model="address.street" :name="`${name}-street`" @input="manualInput">
          Street
        </form-text>
        <form-text v-model="address.city" :name="`${name}-city`" @input="manualInput">
          City
        </form-text>
        <form-select
          v-model="address.state"
          :name="`${name}-state`"
          :options="$store.state.address.states"
          @input="manualInput"
        >
          State
        </form-select>
        <form-text v-model="address.postcode" :name="`${name}-postcode`" @input="manualInput">
          Postcode
        </form-text>

        <input v-model="address.latitude" name="latitude" type="hidden" />
        <input v-model="address.longitude" name="longitude" type="hidden" />
        <input v-model="address.formatted" name="formatted" type="hidden" />

        <div class="form-group row">
          <div class="col-11 text-right">
            <button
              class="btn btn-sm btn-danger"
              style="margin-top: -10px"
              @click.prevent="noAddress"
            >
              <font-awesome-icon :icon="['fal', 'ban']" />
              Set to No Address
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";
import FormGoogleAddress from "./GoogleAddress.vue";

export default {
  components: {
    FormGoogleAddress,
  },
  extends: BaseComponent,

  props: {
    address: {
      default: null,
    },
    addressableId: {
      default: null,
    },
    addressableType: {
      default: null,
    },
    // When replaceable this become a single address input
    replaceable: {
      type: Boolean,
      required: false,
      default: false,
    },
    showResetToNewButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    autoPopulateIfSingle: {
      default: false,
    },
  },

  data() {
    return {
      mode: "select",
      addresses: [],
      selectedAddressId: null,
      expanded: false,
      initalised: false,

      addressProperties: [
        "street",
        "city",
        "state",
        "postcode",
        "latitude",
        "longitude",
        "formatted",
        "shortAddress",
      ],
    };
  },

  computed: {
    title() {
      return this.name.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
    },
  },

  watch: {
    addressableId() {
      this.fetchAddresses();
    },
  },

  created() {
    this.fetchAddresses();
  },

  methods: {
    fetchAddresses() {
      this.initalised = false;
      this.addresses = [];
      this.mode = "google";

      this.selectedAddressId =
        this.address === null || (this.address && this.address.id === undefined)
          ? null
          : this.address.id;

      if (this.addressableId !== null && this.addressableId !== undefined) {
        this.mode = "select";

        // If it is replaceable, do not try to retrieve full addresses list
        if (this.replaceable) {
          this.addresses = [];
          this.mode = "google";
          this.initalised = true;
        } else {
          this.$http
            .get(`/${this.addressableType}s/${this.addressableId}/addresses?limit=999`)
            .then((response) => {
              if (response.body.data && response.body.data.length > 0) {
                this.addresses = response.body.data;

                if (this.autoPopulateIfSingle) {
                  this.populateIfSingle();
                }

                // Default selected address id to first search result
                // if currently selected id is empty
                // Commented out as it default selected address id on addressableId change
                // if (this.selectedAddressId === null && this.addresses.length > 0) {
                //   this.selectedAddressId = this.addresses[0].id;
                //
                //   this.$emit('input', this.selectedAddressId);
                //   this.$emit('addressDefaulted', this.addresses[0]);
                //   if (this.form) {
                //     this.form.errors.clear(this.errorId);
                //   }
                // }
              } else {
                this.addresses = [];
                this.mode = "google";
              }

              this.initalised = true;
            });
        }
      }
    },

    populateIfSingle() {
      if (this.selectedAddressId === null && this.addresses.length === 1) {
        this.selectedAddressId = this.addresses[0].id;

        this.$emit("input", this.selectedAddressId);
        this.$emit("addressDefaulted", this.addresses[0]);
        if (this.form) {
          this.form.errors.clear(this.errorId);
        }
      }
    },

    selected(value) {
      if (value === "") {
        // Selected "Create a new address" option
        this.mode = "google";

        this.address.id = null;
        this.setAddress();
      } else {
        const i = this.addresses.map((a) => a.id).indexOf(parseInt(value, 10));

        this.address.id = this.addresses[i].id;
        this.setAddress(this.addresses[i]);
      }

      this.$emit("input", value);
      this.$emit("updateAddress", this.address);
      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$nextTick(() => {
        if (this.$refs.googleAddress && this.$refs.googleAddress.$refs[this.name]) {
          // noinspection JSUnresolvedFunction
          this.$refs.googleAddress.$refs[this.name].focus();
        }
      });
    },

    googleAddressUpdated(address) {
      if (address instanceof InputEvent) {
        return;
      }

      this.setAddress(address);

      // If in replaceable mode, and selectedAddressId exist
      // Make sure the id stays
      let addressToEmit = window.clone(this.address);
      if (this.replaceable) {
        const idObject = {
          id: this.selectedAddressId,
        };
        addressToEmit = { ...this.address, ...idObject };

        this.$emit("updateAddress", addressToEmit);
      } else {
        this.$emit("input", null);
        this.$emit("updateAddress", addressToEmit);
      }

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }
    },

    manualInput() {
      this.address.latitude = null;
      this.address.longitude = null;
      this.address.street = this.address.street || null;
      this.address.city = this.address.city || null;
      this.address.state = this.address.state || null;
      this.address.postcode = this.address.postcode || null;
      this.address.shortAddress = null;
      this.address.formatted = this.assembleFormatted(this.address);

      if (!this.replaceable) {
        this.$emit("input", null);
      }
      this.$emit("updateAddress", this.address);

      this.$nextTick(() => {
        if (this.$refs.googleAddress && this.$refs.googleAddress.$refs[this.name]) {
          this.$refs.googleAddress.setAddressValue(this.address.formatted);
        }
      });

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }
    },

    setAddress(address) {
      this.addressProperties.forEach((addressProperty) => {
        this.address[addressProperty] = this.$lodash.get(address, addressProperty, null);
      });
    },

    resetToNewAddress() {
      this.mode = "google";
      this.address.id = null;
      this.setAddress();
      this.$emit("updateAddress", this.address);

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }
    },

    noAddress() {
      this.setAddress();

      if (this.$refs.googleAddress && this.$refs.googleAddress.$refs[this.name]) {
        // noinspection JSUnresolvedFunction
        this.$refs.googleAddress.$refs[this.name].clear();
      }
    },

    assembleFormatted(address) {
      return `${address.street || ""}, ${address.city || ""} ${address.state || ""} ${
        address.postcode || ""
      }`
        .replace(/\s\s+/g, " ")
        .trim()
        .replace(/^,/g, "")
        .trim()
        .replace(/,\s*$/, "");
    },

    expand() {
      this.expanded = !this.expanded;
    },

    handleError(place) {
      this.$emit("error", place);
      this.expanded = true;
    },
  },
};
</script>
